var map = {
	"./booking_list.svg": "9be5",
	"./chatroom_list.svg": "1ee2",
	"./coupon_apply.svg": "7c85",
	"./coupon_list.svg": "51a3",
	"./coupon_my.svg": "73a9",
	"./coupon_records.svg": "eced",
	"./coupon_tab_apply.svg": "693f",
	"./coupon_tab_my.svg": "e29d",
	"./coupon_tab_records.svg": "c481",
	"./credit_list.svg": "9d97",
	"./elc_benefit_card.svg": "67d1",
	"./gift_list.svg": "7619",
	"./go_back.svg": "4763",
	"./go_left.svg": "df26",
	"./go_right.svg": "10aa",
	"./groupbuying_list.svg": "7aa2",
	"./groupbuying_order_list.svg": "13b2",
	"./invoice_list.svg": "29d3",
	"./member_center.svg": "6343",
	"./member_edit.svg": "b9db",
	"./new_list.svg": "cf75e",
	"./order_list.svg": "aa57",
	"./point_center.svg": "31ee",
	"./point_exchange.svg": "f88e",
	"./point_exchange_records.svg": "4086",
	"./point_list.svg": "3517",
	"./point_records.svg": "343d",
	"./point_redeem_coupon.svg": "31f0",
	"./point_tab_exchange.svg": "13ad",
	"./point_tab_exchange_records.svg": "5141",
	"./point_tab_records.svg": "7082",
	"./point_tab_redeem_coupon.svg": "fe04",
	"./point_tab_transfer.svg": "ca96",
	"./point_transfer.svg": "938e",
	"./rewards_card.svg": "d71e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "890a";